module.exports = __webpack_public_path__ + "img/yuangong.0790a737.jpg";